import { Accordion, AccordionProps } from '@mui/material';
import { ReactElement } from 'react';

import { useAccordionContext } from './pool-accordion';

export const PoolAccordionItem = (props: AccordionProps): ReactElement => {
    const { index, activeIndex, setActiveIndex } = useAccordionContext();

    return (
        <Accordion
            expanded={index === activeIndex}
            onChange={() => setActiveIndex(index === activeIndex ? null : index)}
            disableGutters={true}
            elevation={0}
            square={true}
            {...props}
        >
            {props.children}
        </Accordion>
    );
};
